export default {
  labels: {
    google_place: 'Google-locatie',
    menu_import: 'Menu-import',
    live: 'Live',
    setting_up: 'Instellen',
  },
  buttons: {
    confirm: 'Bevestigen',
    cancel: 'Annuleren',
    continue_setup: 'Doorgaan met instellen',
  },
  delete_confirmation: 'Weet u het zeker?',
};
